import { useState } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { EmployeeFormValues } from '@/types';
import { AffiliationType, LocationPreference } from '@/api/apis/resources';
import { TXCenter } from '@/api/apis/facilities';
import { OpoOrganization } from '@/api/apis/opo';

type UseContractorAffiliationParams = {
  txCenter?: TXCenter;
  opo?: OpoOrganization;
};

export const useContractorAffiliation = ({ txCenter, opo }: UseContractorAffiliationParams) => {
  const { control, setValue } = useFormContext<EmployeeFormValues>();

  const [locationPreference, affiliationType] = useWatch({
    control,
    name: ['locationPreference', 'affiliationType'],
  });

  const initialTimezone =
    affiliationType === AffiliationType.OPO ? opo?.location.timezone : txCenter?.location.timezone;
  const [affiliationLocationTimezone, setAffiliationLocationTimezone] = useState<string>(initialTimezone || '');

  const isLocationPreferencesAffiliation = locationPreference === LocationPreference.Affiliation;

  const affiliationIanaTimezone = isLocationPreferencesAffiliation ? affiliationLocationTimezone : '';

  const handleTxCenterSelect = (value?: TXCenter) => {
    setAffiliationLocationTimezone(value?.location.timezone || '');
  };

  const handleOpoSelect = (value?: OpoOrganization) => {
    setAffiliationLocationTimezone(value?.location.timezone || '');
  };

  const handleAffiliationTypeChange = (value: string) => {
    setAffiliationLocationTimezone('');
    if (value === AffiliationType.OPO || value === AffiliationType.TXCenter || !isLocationPreferencesAffiliation) {
      return;
    }
    setValue('locationPreference', LocationPreference.Home);
  };

  return {
    handleTxCenterSelect,
    handleOpoSelect,
    handleAffiliationTypeChange,
    affiliationIanaTimezone,
  };
};
